// Vite emits the worker as a fingerprinted static asset and inlines the URL
// at build time. Avoids the `new URL(..., import.meta.url)` resolution that
// can drift across the dynamic-import chunk boundary and 404 in production.
import pdfWorkerUrl from 'pdfjs-dist/build/pdf.worker.min.mjs?url';

let pdfjsLib: typeof import('pdfjs-dist') | null = null;

export async function getPdfJs() {
  if (pdfjsLib) return pdfjsLib;
  pdfjsLib = await import('pdfjs-dist');
  pdfjsLib.GlobalWorkerOptions.workerSrc = pdfWorkerUrl;
  return pdfjsLib;
}

export const STANDARD_FONT_DATA_URL = 'https://unpkg.com/pdfjs-dist@4.10.38/standard_fonts/';
